// extracted by mini-css-extract-plugin
export default {"page-step":"SetUpAccount_page-step__dkmqI","sub-title":"SetUpAccount_sub-title__qX0IF"};